<div class="flex">
  <sbnb-subnav [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav />
  </sbnb-subnav>

  <main class="subnav__exists flex-1" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <span class="text-2xl font-bold">NEW BRAND</span>
  </main>
</div>

<!-- todoben -->
<!-- <sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar> -->
